import { StaffListDataUpdate } from "@/builders/types/staff-list";
import { createFormContext } from "@mantine/form";

interface FormValues {
  first_name: string;
  last_name: string;
  phone_number: string;
  department_id: string;
  career_path_id: string;
  rank_id: string;
  edit_profile: boolean;
}

type TransformFormValues = (values: FormValues) => StaffListDataUpdate;

const [FormProvider, useFormContext, useForm] = createFormContext<
  FormValues,
  TransformFormValues
>();

export { FormProvider, useForm, useFormContext };
